import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('productos');
    if (productsSection) {
      productsSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full bg-[#faf6f0] py-16 md:py-24" data-id="element-35">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-36">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-37">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-38">
            <div className="mb-8" data-id="element-39">
              <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[#1f3d36] mb-2 font-serif" data-id="element-40">
                INTERVENCIÓN DIGITAL
              </h1>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2a2a2a] mb-6 leading-tight font-serif" data-id="element-41">
              Dejá de quedarte hasta las 12 de la noche ideando lo que ya
              existe.
            </h2>

            <p className="text-xl md:text-2xl text-[#4a4a4a] mb-6 leading-relaxed" data-id="element-42">
              Materiales clínicos y educativos listos para descargar, imprimir y
              usar desde el primer día.
            </p>

            <p className="text-lg text-[#6a6a6a] mb-8" data-id="element-43">
              Para psicopedagogas · psicólogas · fonoaudiólogas · maestras de
              apoyo
            </p>

            <motion.button onClick={scrollToProducts} className="inline-flex items-center gap-2 bg-[#1f3d36] text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-[#2d4a3e] transition-colors shadow-lg" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-44">
              Ver todos los materiales
              <ArrowRight className="w-5 h-5" data-id="element-45" />
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-46">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#f5efe6] to-[#faf6f0] aspect-square flex items-center justify-center p-8 md:p-12" data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/hZzG6E1x5oWk8Gajiv1pbh/imagen_intervencion_digital_LOGO-removebg-preview.png" alt="Intervención Digital - Biblioteca Digital" className="w-full h-full object-contain" data-id="element-48" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}